module.exports = __webpack_public_path__ + "img/new_elegant.dcfdeed5.jpg";